/**
 * As consultas no painel do atendimento (#1187): depois de agendar, a aba
 * Cliente mostra a consulta marcada. Sem React, para o teste não precisar de tela.
 */

import type { ConsultaDaOportunidade } from '@cliqcrm/contracts';

export type ConsultaNoPainel = {
  readonly oportunidadeId: string;
  readonly quando: string;
  readonly medico: string | null;
  readonly especialidade: string | null;
  readonly marcada: boolean;
};

const DIAS = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
const MESES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];
const doisDigitos = (n: number) => String(n).padStart(2, '0');

/** "terça, 17 de novembro, às 11:00", no relógio de quem lê. */
export function quandoPorExtenso(iso: string): string {
  const d = new Date(iso);
  return `${DIAS[d.getDay()]}, ${d.getDate()} de ${MESES[d.getMonth()]}, às ${doisDigitos(d.getHours())}:${doisDigitos(d.getMinutes())}`;
}

/**
 * As consultas que ainda vão acontecer, da mais próxima à mais distante. A que
 * já passou, ou sem data, fica de fora: o painel é para quem atende agora.
 */
export function consultasDoPainel(
  consultas: readonly {
    readonly oportunidadeId: string;
    readonly consulta: ConsultaDaOportunidade | undefined;
  }[],
  agora: Date,
): ConsultaNoPainel[] {
  return consultas
    .flatMap(({ oportunidadeId, consulta }) =>
      consulta?.consulta_em && new Date(consulta.consulta_em).getTime() >= agora.getTime()
        ? [{ oportunidadeId, consulta, em: consulta.consulta_em }]
        : [],
    )
    .sort((a, b) => a.em.localeCompare(b.em))
    .map(({ oportunidadeId, consulta, em }) => ({
      oportunidadeId,
      quando: quandoPorExtenso(em),
      medico: consulta.medico?.nome ?? null,
      especialidade: consulta.especialidade?.nome ?? null,
      marcada: consulta.agendamento?.codigo_da_agenda != null,
    }));
}
